import {PasswordInput, Input, Button, Title, Grid} from "@mantine/core";
import React, {useState, useRef} from "react";
import Turnstile from "react-turnstile";
import { IconLock, IconAt, IconUser, IconLogin } from '@tabler/icons-react';

import {SystemMemoryProps} from "../../models/SystemMemoryProps";
import {NavMenu} from "../../components/GetNavMenu";
import {Footer} from "../../components/GetFooter";
import {FormContainer} from "../../components/form/FormContainer";
import {registerForm} from "../../logic/forms/RegisterForm";
import {updateSubmit} from "../../logic/UpdateSubmit";
import {RegisterFormModel} from "../../models/forms/RegisterFormModel";
import {useLocation} from "react-router-dom";

async function RegisterSubmit (body: RegisterFormModel) {
    // Clear notification banner and set button to loading state
    updateSubmit(body.submitButton, 'Registering', true);
    body.setBanner(<></>)

    await registerForm(body);
    updateSubmit(body.submitButton, 'Register', false);
}

export function Register({memory}: SystemMemoryProps) {
    // Check if the user has supplied a code in the URL
    const { search } = useLocation();
    const queryParams = new URLSearchParams(search);
    let code = queryParams.get("code");

    const inputs = {
        email: useRef(null),
        firstName: useRef(null),
        lastName: useRef(null),
        password: useRef(null),
        passwordConfirm: useRef(null),
        accessCode: useRef(null),
        cfTurnstileToken: useRef("null")
    }

    // Create notification states
    const [notification, setNotification] = useState(<></>)

    // Check if the user is already logged in, if so redirect to the dashboard
    if (memory[0].isSignedIn) {
        memory[0].Router('/account/dashboard');
    }

    // Create submit button state with the submit button within it
    const submit = useState(
        <Button variant="light" color="indigo" radius="md" size="md" uppercase
                onClick={() => RegisterSubmit({
                    memory: {memory},
                    setBanner: setNotification,
                    submitButton: submit,
                    inputs: inputs
                })}>
            Register
        </Button>
    );

    // Create the register form
    const form = (
        <>
            {notification}<br/>
            <Title align="center">Create an Account</Title>
            <Input.Label required size={"lg"}>Email Address</Input.Label>
            <Input
                placeholder="Your email"
                icon={<IconAt size={"1rem"}/>}
                variant="filled"
                radius="md"
                size="lg"
                ref={inputs.email}
            /><br/>
            <Grid>
                <Grid.Col span={6}>
                    <Input.Label required size={"lg"}>First Name</Input.Label>
                    <Input
                        placeholder="Your name"
                        icon={<IconUser size={"1rem"}/>}
                        variant="filled"
                        radius="md"
                        size="lg"
                        ref={inputs.firstName}
                    />
                </Grid.Col>
                <Grid.Col span={6}>
                    <Input.Label required size={"lg"}>Last Name</Input.Label>
                    <Input
                        placeholder="Your surname name"
                        icon={<IconUser size={"1rem"}/>}
                        variant="filled"
                        radius="md"
                        size="lg"
                        ref={inputs.lastName}
                    />
                </Grid.Col>
            </Grid><br/>
            <Input.Label required size={"lg"}>Password</Input.Label>
            <PasswordInput
                placeholder="Password"
                icon={<IconLock size={"1rem"}/>}
                variant="filled"
                radius="md"
                size="lg"
                ref={inputs.password}
            /><br/>
            <Input.Label required size={"lg"}>Confirm Password</Input.Label>
            <PasswordInput
                placeholder="Repeat Password"
                icon={<IconLock size={"1rem"}/>}
                variant="filled"
                radius="md"
                size="lg"
                ref={inputs.passwordConfirm}
            /><br/>
            <Input.Label required size={"lg"}>Access Code</Input.Label>
            <Input.Description size={"md"}>An access code is provided by a system administrator, so you can register.</Input.Description>
            <Input
                placeholder="Registration access code"
                icon={<IconLogin size={"1rem"}/>}
                variant="filled"
                radius="md"
                size="lg"
                ref={inputs.accessCode}
                defaultValue={code ? code : ""}
            /><br/>
            <center>
                <Turnstile
                    sitekey={memory[0].CFSiteKey}
                    onVerify={(token) => {
                        inputs.cfTurnstileToken.current = token
                    }}/><br/>
                {submit[0]}
            </center>
        </>
    )

    return (
        <>
            <NavMenu memory={memory}></NavMenu>
            {FormContainer(form)}
            <Footer data={[]}></Footer>
        </>
    )
}